module.exports = __webpack_public_path__ + "img/bakTop.0e5a1cbb.png";